// extracted by mini-css-extract-plugin
export default {"spinner":"Nqy7nzSAI3rsc5RA26Ab","animation-spin":"OO9A4EwnU5CnzaSPNa2E"};